import { convertObjectToSearchParams } from '../../../utils/convert-object-to-search-params';
import { getCaptchaRequestConfig } from '../../../utils/get-captcha-request-config';
import { getAddFriendFromCodeErrorV1 } from './errors/add-friend-from-code-error';
import { getCreateFriendCodeErrorV1 } from './errors/create-friend-code-error';
import { getCreateMemberErrorV1 } from './errors/create-member-error';
import { getCreateMemberPasswordResetCodeErrorV1 } from './errors/create-member-password-reset-code-error';
import { getEmailAvailabilityErrorV1 } from './errors/email-availability-error';
import { getResetMemberPasswordErrorV1 } from './errors/reset-member-password-error';
import { getSetEmailErrorV1 } from './errors/set-email-error';
import { getSetFutureRecurringSubscriptionErrorV1 } from './errors/set-future-recurring-subscription-error';
import { getSetMemberPhotoErrorV1 } from './errors/set-member-photo-error';
import { getSetPasswordErrorV1 } from './errors/set-password-error';
import { getSetPersonalDetailsErrorV1 } from './errors/set-personal-details-error';
import { getSetSubscriptionSharingErrorV1 } from './errors/set-subscription-sharing-error';
import { getSetUsernameErrorV1 } from './errors/set-username-error';
import { getSignInErrorV1 } from './errors/sign-in-error';
import { loyaltyApiRoutes as routes } from './routes';
export function getLoyaltyApiV1(httpClient) {
    return {
        masterData: {
            get: ()=>httpClient.get(routes.masterData.get())
        },
        members: {
            create: (member, captchaResponse)=>httpClient.post(routes.members.create(), member, getCaptchaRequestConfig(captchaResponse)).catch(async (e)=>{
                    throw await getCreateMemberErrorV1(e);
                })
            ,
            getCurrent: ()=>httpClient.get(routes.members.getCurrent())
            ,
            validateEmailAvailability: (request)=>httpClient.post(routes.members.validateEmailAvailability(), request).catch(async (e)=>{
                    throw await getEmailAvailabilityErrorV1(e);
                })
            ,
            authentication: {
                createToken: (request, captchaResponse)=>httpClient.post(routes.members.authentication.createToken(), convertObjectToSearchParams(request), getCaptchaRequestConfig(captchaResponse)).catch(async (e)=>{
                        throw await getSignInErrorV1(e, request.grant_type);
                    })
                ,
                createCookie: (request, captchaResponse)=>httpClient.post(routes.members.authentication.createCookie(), convertObjectToSearchParams(request), getCaptchaRequestConfig(captchaResponse)).catch(async (e)=>{
                        throw await getSignInErrorV1(e, request.grant_type);
                    })
                ,
                expireCookie: ()=>httpClient.delete(routes.members.authentication.expireCookie())
            },
            friends: {
                createCode: (request)=>httpClient.post(routes.members.friends.createCode(), request).catch(async (e)=>{
                        throw await getCreateFriendCodeErrorV1(e);
                    })
                ,
                addFromCode: (request)=>httpClient.post(routes.members.friends.addFromCode(), request).catch(async (e)=>{
                        throw await getAddFriendFromCodeErrorV1(e);
                    })
                ,
                remove: (friendId)=>httpClient.delete(routes.members.friends.remove(friendId))
                ,
                setSubscriptionSharing: (friendId, request)=>httpClient.put(routes.members.friends.setSubscriptionSharing(friendId), request).catch(async (e)=>{
                        throw await getSetSubscriptionSharingErrorV1(e);
                    })
            },
            journeys: {
                getCurrent: ()=>httpClient.get(routes.members.journeys.getCurrent())
                ,
                getPast: (query)=>httpClient.get(routes.members.journeys.getPast(), {
                        queryParams: query
                    })
            },
            passwordReset: {
                createCode: (passwordResetCodeCreate, captchaResponse)=>httpClient.post(routes.members.passwordReset.createCode(), passwordResetCodeCreate, getCaptchaRequestConfig(captchaResponse)).catch(async (e)=>{
                        throw await getCreateMemberPasswordResetCodeErrorV1(e);
                    })
                ,
                validateCode: (passwordResetCodeValidation)=>httpClient.post(routes.members.passwordReset.validateCode(), passwordResetCodeValidation)
                ,
                reset: (passwordReset)=>httpClient.post(routes.members.passwordReset.reset(), passwordReset).catch(async (e)=>{
                        throw await getResetMemberPasswordErrorV1(e);
                    })
            },
            paymentCards: {
                getAll: ()=>httpClient.get(routes.members.paymentCards.getAll())
                ,
                getById: (memberPaymentCardId)=>httpClient.get(routes.members.paymentCards.getById(memberPaymentCardId))
                ,
                remove: (memberPaymentCardId)=>httpClient.delete(routes.members.paymentCards.remove(memberPaymentCardId))
                ,
                setPrimary: (memberPrimaryPaymentCardUpdate)=>httpClient.put(routes.members.paymentCards.setPrimary(), memberPrimaryPaymentCardUpdate)
                ,
                createEmbedded: (embeddedMemberPaymentCardCreate)=>httpClient.post(routes.members.paymentCards.createEmbedded(), embeddedMemberPaymentCardCreate)
            },
            rewards: {
                getAll: ()=>httpClient.get(routes.members.rewards.getAll())
            },
            subscriptions: {
                setVistaAsSubscriptionPaymentProvider: ()=>httpClient.put(routes.members.subscriptions.setVistaAsSubscriptionPaymentProvider(), {})
                ,
                setFutureRecurring: (request)=>httpClient.post(routes.members.subscriptions.setFutureRecurring(), request).catch(async (e)=>{
                        throw await getSetFutureRecurringSubscriptionErrorV1(e);
                    })
                ,
                reactivateCurrent: ()=>httpClient.post(routes.members.subscriptions.reactivateCurrent(), {})
                ,
                cancelCurrent: ()=>httpClient.delete(routes.members.subscriptions.cancelCurrent(), {})
            },
            ticketRedemptionCards: {
                getAll: ()=>httpClient.get(routes.members.ticketRedemptionCards.getAll())
            },
            transactions: {
                get: (query)=>httpClient.get(routes.members.transactions.get(), {
                        queryParams: query
                    })
            },
            update: {
                setPersonalDetails: (memberPersonalDetails, captchaResponse)=>httpClient.put(routes.members.update.setPersonalDetails(), memberPersonalDetails, getCaptchaRequestConfig(captchaResponse)).catch(async (e)=>{
                        throw await getSetPersonalDetailsErrorV1(e);
                    })
                ,
                setEmail: (emailUpdate, captchaResponse)=>httpClient.put(routes.members.update.setEmail(), emailUpdate, getCaptchaRequestConfig(captchaResponse)).catch(async (e)=>{
                        throw await getSetEmailErrorV1(e);
                    })
                ,
                setPassword: (passwordUpdate, captchaResponse)=>httpClient.put(routes.members.update.setPassword(), passwordUpdate, getCaptchaRequestConfig(captchaResponse)).catch(async (e)=>{
                        throw await getSetPasswordErrorV1(e);
                    })
                ,
                setUsername: (usernameUpdate, captchaResponse)=>httpClient.put(routes.members.update.setUsername(), usernameUpdate, getCaptchaRequestConfig(captchaResponse)).catch(async (e)=>{
                        throw await getSetUsernameErrorV1(e);
                    })
                ,
                setPhoto: (photoFormData)=>httpClient.put(routes.members.update.setPhoto(), photoFormData).catch(async (e)=>{
                        throw await getSetMemberPhotoErrorV1(e);
                    })
            },
            watchedFilms: {
                get: (query)=>httpClient.get(routes.members.watchedFilms.get(), {
                        queryParams: query
                    })
            },
            watchlistFilms: {
                getAll: ()=>httpClient.get(routes.members.watchlistFilms.getAll())
                ,
                add: (film)=>httpClient.post(routes.members.watchlistFilms.add(), film)
                ,
                remove: (filmId)=>httpClient.delete(routes.members.watchlistFilms.remove(filmId))
            }
        }
    };
}

//# sourceMappingURL=get-loyalty-api.js.map